import React, { useState } from 'react';
import { IconButton, MenuItem, Stack, TextField, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { SettingsOption } from 'src/model/api/v2/data-contracts';
import { ROLE_SELECT_WIDTH } from 'src/pages/ProfileSettingsPage/components/ParticipantRow';
import { ts } from 'src/utils/translate';

// the legacy page preselects the Technician occupation type (id 1) for a new participant
const DEFAULT_ROLE_ID = 1;

type Props = {
    roles: SettingsOption[];
    disabled: boolean;
    onConfirm: (email: string, roleId: number) => void;
    onCancel: () => void;
};

export const NewParticipantRow = ({ roles, disabled, onConfirm, onCancel }: Props) => {
    const [email, setEmail] = useState('');
    const [roleId, setRoleId] = useState(
        roles.some(role => role.id === DEFAULT_ROLE_ID) ? DEFAULT_ROLE_ID : roles[0]?.id ?? DEFAULT_ROLE_ID
    );

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <TextField
                size="small"
                type="email"
                autoFocus
                sx={{ flex: 1 }}
                placeholder={ts('email_placeholder', 'E-mail address')}
                value={email}
                disabled={disabled}
                onChange={(event) => setEmail(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') onConfirm(email, roleId);
                    else if (event.key === 'Escape') onCancel();
                }}
            />
            <TextField
                select
                size="small"
                value={roleId}
                disabled={disabled}
                onChange={(event) => setRoleId(Number(event.target.value))}
                sx={{ width: ROLE_SELECT_WIDTH, flexShrink: 0 }}
            >
                {roles.map((role) => (
                    <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>
                ))}
            </TextField>
            <Tooltip title={ts('plt_add_par_to_list', 'Add participant to this list')}>
                <span>
                    <IconButton size="small" color="primary" disabled={disabled} onClick={() => onConfirm(email, roleId)}>
                        <CheckIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={ts('plt_cancel', 'Cancel')}>
                <span>
                    <IconButton size="small" disabled={disabled} onClick={onCancel}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </Stack>
    );
};
